// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterClinic_root__2E0W7"};